import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Material modules
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';

// Component and pipes
import { MarkdownPipe } from './markdown.pipe';
import { TestDataAgentSSERoutingModule } from './test-data-agent-sse-routing.module';
import { TestDataAgentSSEComponent } from './test-data-agent-sse.component';

@NgModule({
  declarations: [TestDataAgentSSEComponent, MarkdownPipe],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatTabsModule,
    MatCardModule,
    TestDataAgentSSERoutingModule,
  ],
  exports: [MarkdownPipe], // Export the pipe for use in other modules
})
export class TestDataAgentSSEModule {}
